import React from "react";
import styles from "./TextCard.module.scss";
import Image from "next/image";

interface DataCardProps {
  title: string;
  bg_image: string;
  subTitle?: string;
  content?: string;
  layout?: string;
  description?: string[];
}

const TextCard = ({
  title,
  bg_image,
  subTitle,
  description,
                    content = "text",
  layout="column"
}: DataCardProps) => {
  return (
    <div className={`${styles.dataCard} ${layout==="row"?styles.dataRowCard:""}`}>
      <div className={styles.titleCard}>
        <div className={styles.titleCardImage}>
          <Image src={bg_image} alt="title-card-bg" height={80} width={296} />
        </div>
        <div className={styles.contentWrapper}>
          <h4>{title}</h4>
          <p>{subTitle}</p>
        </div>
      </div>
      {description && (
        <div className={styles.cardText}>
          {
            content === 'list' ? (
              <ul className={styles.dataList}>
                {description?.map((val, index) => (
                  <li key={index}>{val}</li>
                ))}
              </ul>
            ) : (
              <>
                {description?.map((val, index) => (
                  <p key={index}>{val}</p>
                ))}
              </>
            )
          }

        </div>
      )}
    </div>
  );
};

export default TextCard;
